import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { getProfileRole, IConsultantProfile } from "@/data/consultant-profiles";
import { Flex } from "@/eworkitComponents";

interface IOnboardingProfileTypeBoxProps {
  profile: IConsultantProfile;
}

export const OnboardingProfilesRecord: FC<IOnboardingProfileTypeBoxProps> = ({ profile }) => {
  const { t } = useTranslation("session");
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const eworkCompany = t("ONBOARDING.PROFILES_LIST.EWORK_COMPANY");
  const { contactPerson } = profile.personalInvitationContactPerson
    ? {
        contactPerson: {
          firstName: profile.personalInvitationContactPerson.contactFirstName,
          lastName: profile.personalInvitationContactPerson.contactLastName,
          email: profile.personalInvitationContactPerson.contactEmail,
        },
      }
    : profile;

  return (
    <Flex
      grow={1}
      direction={isSmallScreen ? "column" : "row"}
      innerMargin="md"
      border={[false, false, true, false]}
      padding={["md", false]}>
      <Flex width={4} innerMargin="sm">
        <Icon icon="user" size="lg" color="grey2" />
        <Text size="lg" weight="bold" hjSuppress testName="profileName">
          {`${profile.firstName} ${profile.lastName}`}
        </Text>
      </Flex>
      <Flex width={4} direction="column">
        <Text
          size="lg"
          hjSuppress
          testName="contactName">{`${contactPerson.firstName} ${contactPerson.lastName}`}</Text>
        <Text color="grey1" hjSuppress testName="contactEmail" ellipsis>
          {contactPerson.email}
        </Text>
      </Flex>
      <Flex width={2}>
        <Text size="lg" testName="companyName">
          {profile.sharedProfile ? profile.sharedProfile.company.name : eworkCompany}
        </Text>
      </Flex>
      <Flex width={2}>
        <Text size="lg" testName="companyRole">
          {t(
            `CONSULTANT_PROFILES.DETAIL.PROFILE_ROLE.${
              profile.companyInvitation
                ? getProfileRole(profile.companyInvitation.type)
                : getProfileRole(profile.companyRole)
            }`,
          )}
        </Text>
      </Flex>
    </Flex>
  );
};
